<template>
  <!-- eslint-disable-next-line vue/component-name-in-template-casing -->
  <klarna-placement
    data-key="credit-promotion-auto-size"
    :data-locale="locale"
    :data-purchase-amount="purchaseAmount"
  >
  </klarna-placement>
</template>

<script setup lang="ts">
/**
 * This component is a wrapper around the klarna custom element.
 * It takes care of formatting the props to match the klarna custom element API.
 * /!\ It's up to the parent component to load the klarna script with `useKlarnaLibrary`
 *
 * Uses the current i18n locale (e.g. es-US on /es-us) so Klarna advertising
 * displays in the user's language.
 *
 * List of supported attributes: https://docs.klarna.com/acquirer/klarna/on-site-messaging/additional-resources/placements/#attributes
 */
import { computed } from 'vue'

import type { Price } from '@backmarket/http-api'
import type { PaymentMethod } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { priceToMinorUnits } from '@backmarket/utils/math/priceToMinorUnits'
import { toRfc4646Locale } from '@backmarket/utils/string/toRfc4646Locale'

const props = defineProps<{
  paymentMethod: PaymentMethod
  basePrice: Price
}>()

const i18nLocale = useI18nLocale()
const locale = computed(() => toRfc4646Locale(i18nLocale))
const purchaseAmount = computed(() => priceToMinorUnits(props.basePrice))
</script>

<style scoped>
klarna-placement::part(osm-container) {
  background-color: transparent;
  font-size: inherit;
  border: none;
  padding: 0;
  text-align: left; /* to be consistent with the paypal banner */
}

klarna-placement::part(osm-badge-container) {
  width: 50px;
}
</style>
